import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import SummaryApi from '../common';
import moment from 'moment';
import displayINRCurrency from '../helpers/displayCurrency';
import { MdModeEdit } from 'react-icons/md'; // Edit Icon
import ChangeRequestStatus from '../components/ChangeRequestStatus'; // Import Modal
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ROLE from '../common/role';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';

const AdminViewUserRequest = () => {
    const { userId } = useParams(); 
    const location = useLocation();
    const { type } = location.state || {}; 
    const [data, setData] = useState([]);
    const [userDetails, setUserDetails] = useState({});
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [openChangeStatus, setOpenChangeStatus] = useState(false);
    const [selectedRequest, setSelectedRequest] = useState(null);
    const user = useSelector(state => state?.user?.user);
    const [loadingPage, setLoadingPage] = useState(false);
    const navigate = useNavigate();

      // Default startDate and endDate for the current month
  const [startDate, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'));

    const fetchDeptRequestDetails = async () => {
        try {

            const query = new URLSearchParams({
                type,
                startDate: startDate ? moment(startDate).toISOString() : '',
                endDate: endDate ? moment(endDate).toISOString() : '',
              }).toString();

            const response = await fetch(`${SummaryApi.adminGetDeptRequests.url}/${userId}?${query}`, {
                method: SummaryApi.adminGetDeptRequests.method,
                credentials: 'include'
            });
            const responseData = await response.json();
            if (responseData.success) {
                setData(responseData.data || []);
            } else {
                setError(responseData.message);
                setData([]);
            }
        } catch (error) {
            setError('Error fetching dept requests');
            setData([]);
        }
    };
    

    const fetchUserDetails = async () => {
        try {
            const response = await fetch(`${SummaryApi.getUserById.url}/${userId}`, {
                method: SummaryApi.getUserById.method,
                credentials: 'include',
            });
            const responseData = await response.json();
            if (responseData.success) {
                setUserDetails(responseData.data || {});
            } else {
                setError(responseData.message);
            }
        } catch (error) {
            setError('Error fetching user details');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDeptRequestDetails();
        fetchUserDetails();
    }, [userId,startDate, endDate]);

    const getStatusColor = (status) => {
        switch (status) {
            case 'accepted':
                return 'bg-blue-900 text-white';
            case 'pending':
                return 'bg-yellow-600 text-white';
            case 'rejected':
                return 'bg-red-800 text-white';
            case 'done':
                return 'bg-green-700 text-white';
            default:
                return 'bg-gray-700 text-white';
        }
    };
    const refreshData = async () => {
        await fetchDeptRequestDetails();
        await fetchUserDetails();
    };

    useEffect(() => {
        setLoadingPage(true);
        const loadingTimeout = setTimeout(() => {
          
          setLoadingPage(false);
          navigate("/");
        }, 10000); 
    
        if (user) {
          if (user?.role !== ROLE.ADMIN) {
            navigate('/');
            setLoadingPage(false);
          } 
          else {
            if(user?.type === "Admin"){
                navigate('/admin-panel/all-users');
                setLoadingPage(false);
            }
            else{
                setLoadingPage(false);
                clearTimeout(loadingTimeout);
            }
           
          }
        } 
    
        // Clear the timeout when the component unmounts or the effect is rerun
        return () => clearTimeout(loadingTimeout);
      }, [user, navigate]);

      if (loadingPage) {
        return (
            <div className="flex justify-center items-center h-screen">
                <AiOutlineLoading3Quarters className="animate-spin text-6xl text-blue-500" />
            </div>
        );
    }
  
    

    return (
        <div className='bg-white pb-4 px-4'>
            {loading ? (
                <p>Loading...</p>
            ) : error ? (
                <p>{error}</p>
            ) : (
                <>
                <div className="mb-4 p-4 border border-gray-300 bg-gray-100 rounded ">
                    <h2 className="text-xl font-bold mb-2">معلومات المستخدم</h2>
                    {userDetails.profilePic && (
                        <img src={userDetails.profilePic} alt="Profile" className="w-24 h-24 rounded-full" />
                    )}
                    <p className="mb-1"> {userDetails.name || 'N/A'}<strong>: الاسم</strong></p>
                    <p className="mb-1">{userDetails.email || 'N/A'} <strong>: البريد الالكترونى</strong> </p>

                    {type==='Medicine' &&
                    <p className="mb-1">
                        {userDetails?.medicineDebt?.$numberDecimal
                        ? displayINRCurrency (Number(userDetails.medicineDebt.$numberDecimal).toFixed(2))
                        : displayINRCurrency(0)}
                        <strong>: المديونية</strong>
                    </p>
                    }
                    {type==='Cosmetic' &&
                    <p className="mb-1">
                        {userDetails?.cosmeticDebt?.$numberDecimal
                        ? displayINRCurrency (Number(userDetails.cosmeticDebt.$numberDecimal).toFixed(2))
                        : displayINRCurrency(0)}
                        <strong>: المديونية</strong>
                    </p>
                    }

                    <p className="mb-1"> {userDetails.shippingAddress || 'N/A'} <strong>: العنوان</strong></p>
                    <p className="mb-1"> {userDetails.mobileNumber || 'N/A'} <strong>: رقم الهاتف المحمول</strong></p>

                </div>

                {/* Date Filter Section */}
<div className="flex justify-end items-start mb-4">
  <div className="text-right">
    <h2 className="text-xl font-bold mb-6">حدد المدة التي تريد ان تري بها مديونيات المستخدم</h2>

    <div className="flex gap-6 justify-end">
      {/* Start Date */}
      <div>
        <label htmlFor="startDate" className="block text-sm font-medium text-gray-700">
          تاريخ البداية
        </label>
        <input
          type="date"
          id="startDate"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          className="mt-1 p-2 block w-full border border-gray-300 rounded-md"
        />
      </div>

      {/* End Date */}
      <div>
        <label htmlFor="endDate" className="block text-sm font-medium text-gray-700">
          تاريخ النهاية
        </label>
        <input
          type="date"
          id="endDate"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          className="mt-1 p-2 block w-full border border-gray-300 rounded-md"
        />
      </div>
    </div>
  </div>
</div>

                    {data.length === 0 ? (
                        <p>لا يوجد مدفوعات حاليا </p>
                    ) : (
                        <div className='overflow-x-auto'>
                            <table className='w-full border-collapse border border-gray-300'>
                                <thead>
                                    <tr className='bg-black text-white'>
                                        <th className='py-2 px-4 border border-gray-300'>كود المديونية</th>
                                        <th className='py-2 px-4 border border-gray-300'>التاريخ</th>
                                        <th className='py-2 px-4 border border-gray-300'>الكمية</th>
                                        <th className='py-2 px-4 border border-gray-300'>اسم مندوب المبيعات</th>
                                     {/*   <th className='py-2 px-4 border border-gray-300'>البريد الالكترونى مندوب المبيعات</th>* */}
                                        <th className='py-2 px-4 border border-gray-300'>رقم الهاتف المحمول للمندوب</th>
                                        <th className='py-2 px-4 border border-gray-300'>حالة الدفع</th>
                                        <th className='py-2 px-4 border border-gray-300'>تغيير الحالة</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, index) => (
                                        <tr key={item._id || index} className="min-h-[80px] border-t border-gray-300">
                                            <td className="text-center py-2 px-4 border border-gray-300">#{item.paymentCode}</td>
                                            <td className="text-center py-2 px-6 border border-gray-300">{moment(item.createdAt).format('LLL')}</td>
                                            <td className="text-center py-2 px-6 border border-gray-300">{displayINRCurrency(item.deptQuantity)}</td>
                                            <td className="text-center py-2 px-6 border border-gray-300">{item.salesManName}</td>
                                         {/*    <td className="text-center py-2 px-6 border border-gray-300">{item.salesManEmail}</td>*/}
                                            <td className="text-center py-2 px-6 border border-gray-300">{item.salesManMobileNumber}</td>
                                            <td className={`text-center py-2 px-4 border border-gray-300 ${getStatusColor(item.state)}`}>
                                                {item.state === 'accepted' && '  المبلغ مع مندوب المبيعات  '}
                                                {item.state === 'done' && 'تم تحصيل المبلغ الي الشركة بنجاح '}
                                                {item.state === 'rejected' && 'عملية مرفوضة'}
                                                {item.state === 'pending' && 'قيد المراجعة'}
                                                {item.state !== 'accepted' && item.state !== 'rejected' && item.state !== 'pending'&& item.state !== 'done' && item.state}
                                            </td>
                                            <td className="text-center py-2 px-6 border border-gray-300">
                                                {item.state === 'accepted' && (
                                                    <button
                                                        className="bg-green-100 p-2 rounded-full cursor-pointer hover:bg-green-500 hover:text-white"
                                                        onClick={() => {
                                                            setSelectedRequest(item);
                                                            setOpenChangeStatus(true);
                                                        }}
                                                    >
                                                        <MdModeEdit size={20} />
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {/* Change Status Modal */}
                    {openChangeStatus && selectedRequest && (
                        <ChangeRequestStatus
                            requestId={selectedRequest._id}
                            currentStatus={selectedRequest.state}
                            onClose={() => setOpenChangeStatus(false)}
                            callFunc={refreshData}
                            type={type}
                        />
                    )}
                </>
            )}
        </div>
    );
};

export default AdminViewUserRequest;
